import ShippingInformationStore from './ShippingInformationStore'

export default ShippingInformationStore
